import Vue from 'vue'
import App from './App'

import Keystone from '@db2b/keystone'
let ks = new Keystone(process.keystone)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router: ks.router(),
  store: ks.store(),
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js